// const API_URL = "http://localhost:5001"

const API_URL = "https://dashboard-backend-delta.vercel.app";

export default API_URL;
